import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    depots: (count: number) => translate({ id: 'global.counter.depots', values: { count } }),
    multipleValues: translate({ id: 'global.multipleValues' }),
  }))

  return api
}
